import handleOpenLink from '@kognitiv/bf-library/dist/esm/helpers';
import { UrlTransformers } from 'Shared/urltransformer/UrlTransformers';

const Redirect = ({ domain, query }, newTabDisabled) => {
    const queryString = Object.keys(query).map(key => `${key}=${query[key]}`).join('&');
    let sanitizedDomain = domain.replace('https://', '');
    sanitizedDomain = sanitizedDomain.replace('http://', '');

    const linkUrl = `https://${sanitizedDomain}?${queryString}`;

    UrlTransformers.instance().transform(linkUrl)
        .then(transformedUrl => {
            handleOpenLink(transformedUrl, newTabDisabled);
        });
};

export default Redirect;
